'use strict';

/**
 * @description Codigo de red Component
 * @returns {Object} Devuelve la instancia del componente
 */

import { store } from '../../app.init.js';
import { servicesRedMercado } from './codigoRedMercado.services';
import { templateRedMercado } from './codigoRedMercado.template';
import i18n from 'i18next';

let componentRedMercado = (function () {
  let context = {};
  let handlers = {};
  let renderSuccess = false;

  let preRenderComponent = () => {
    // Asi accedemos a la propiedad del store
    const state = store.getState();
    document.title = `${i18n.t('market_network_codes_title')} | ${i18n.t(
      'page_subtitle'
    )}`;
    context.name = state.exampleReducer.name;
  };

  let renderComponent = async () => {
    const state = store.getState();
    try {
      // Render the template to the document
      let contactData = await servicesRedMercado.init(
        state.exampleReducer.currentLang
      );
      templateRedMercado(contactData);
      changetab(contactData);
      renderSuccess = true;
    } catch (error) {
      renderSuccess = false;
    }
  };

  const changetab = () => {
    document.querySelectorAll('a[href^="#"]').forEach((a) => {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var href = this.getAttribute('href');
        var elem =
          document.querySelector(href) ||
          document.querySelector(
            'a[name=' + href.substring(1, href.length) + ']'
          );
        var elemPosition = elem.getBoundingClientRect().top + window.scrollY;
        window.scroll({
          top: elemPosition,
          left: 0,
          behavior: 'instant',
        });
      });
    });
  };

  let postRenderComponent = () => {
    const state = store.getState();
    context.name = state.exampleReducer.name;
  };

  let init = () => {
    //Call pre render component
    preRenderComponent();

    // Call render component
    renderComponent();
    // Call post render component if it has been rendered
    renderSuccess ? postRenderComponent() : '';
  };

  return {
    render: init,
  };
})();

export { componentRedMercado };
